import * as XLSX from 'xlsx';

export const exportToExcel = (data: any[], filename: string = 'export') => {
  // Create worksheet from data
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Set column widths
  worksheet['!cols'] = [
    { wch: 20 }, // Customer Name
    { wch: 15 }, // Phone
    { wch: 18 }, // Date
    { wch: 15 }, // Category
    { wch: 50 }, // Issue Summary
    { wch: 60 }, // Call Summary
    { wch: 40 }, // Action Required
    { wch: 15 }, // Priority Score
    { wch: 12 }, // Urgency
    { wch: 12 }, // Status
    { wch: 10 }, // Channel
    { wch: 10 }, // Callback Requested
    { wch: 12 }, // Human Transfer
    { wch: 12 }, // Escalation
    { wch: 30 }, // Notes
  ];
  
  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
  
  // Generate filename with timestamp
  const timestamp = new Date().toISOString().split('T')[0];
  const fullFilename = `${filename}_${timestamp}.xlsx`;
  
  // Write file
  XLSX.writeFile(workbook, fullFilename);
};

export const exportNextStepsToExcel = (actions: any[]) => {
  const exportData = actions.map(action => ({
    'Customer Name': action.customer_name || 'Unknown',
    'Phone': action.customer_phone || '',
    'Date': action.created_at ? new Date(action.created_at).toLocaleString() : '',
    'Category': action.issue_category || 'General',
    'Issue Summary': action.issue_details || '',
    'Call Summary': action.call_summary || '',
    'Action Required': action.action_required || 'Review required',
    'Priority Score': action.priorityScore || 0,
    'Urgency': action.urgency_level || 'Medium',
    'Status': action.resolved ? 'Completed' : 'Pending',
    'Channel': action.channel_type || 'VOICE',
    'Callback Requested': action.callback_requested ? 'Yes' : 'No',
    'Human Transfer': action.human_transfer_requested ? 'Yes' : 'No',
    'Escalation': action.escalation_requested ? 'Yes' : 'No',
    'Notes': action.action_required || ''
  }));
  
  exportToExcel(exportData, 'next-steps-report');
};

